export const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5050';

export const apiFetch = (path, options = {}) => {
  return fetch(`${BASE_URL}${path}`, options).then(res => {
    if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
    return res.json();
  });
};